import EditAdvertisement from './EditAdvertisement'

export default EditAdvertisement
